import React, { useEffect, useState } from "react";

import { Outlet, useNavigate, useParams } from "react-router-dom";

import { useExercise } from "../hooks/exerciseHook";
import { getRequest } from "../../api/axiosRequests";
import Failed from "../../loading/pages/Failed";
import Loading from "../../loading/pages/Loading";
import ContainerResponsive from "../../common/components/ContainerResponsive";
import PlanHeader from "./ExerciseHeader";
import { useAuth } from "../../auth/hook";

export default function ExerciseLayout() {
  const navigate = useNavigate();
  const { idExercise } = useParams();
  const exerciseContext = useExercise();
  const userAuth = useAuth();
  const [isLoaded, setIsLoaded] = useState(false);
  const [isFailed, setIsFailed] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const token = localStorage.getItem("jwt");
    if (!token || token === "" || token === undefined || token === null) {
      navigate("/login");
      return;
    }
    const headers = { Authorization: localStorage.getItem("jwt") };
    const promiseUser = getRequest("userData/", headers);
    const promiseExercise = getRequest("exercise/" + idExercise, headers);
    const promiseSubscription = getRequest(
      "currentUserSubscription/" + userAuth.user.id,
      headers
    );
    Promise.all([promiseUser, promiseExercise, promiseSubscription])
      .then((values) => {
        const userRole = values[0].data["role"];
        let exerciseData = values[1].data;
        const userSubscription = values[2].data;

        const hasSubscription =
          userSubscription.id && userSubscription.id != -1;
        const isAdmin = userRole == "Admin";
        exerciseData.isLocked = !isAdmin && !hasSubscription;
        exerciseContext.setExerciseData(exerciseData);
        setIsLoaded(true);
        setIsFailed(false);
      })
      .catch((errs) => {
        setIsLoaded(true);
        setIsFailed(true);
      });
  }, []);

  return (
    <>
      {!isLoaded && (
        <>
          <PlanHeader title={""} showInfo={false} showBackground={false} />
          <ContainerResponsive>
            <Loading paddingTop={30} />
          </ContainerResponsive>
        </>
      )}
      {isLoaded && isFailed && (
        <>
          <PlanHeader title={""} showInfo={false} showBackground={false} />
          <ContainerResponsive>
            <Failed
              mainDescription={"Errore durante la connessione al server."}
              secondaryDescription={
                "Controlla la tua connessione e riprova più tardi."
              }
              paddingTop={30}
            />
          </ContainerResponsive>
        </>
      )}
      {isLoaded && !isFailed && <Outlet />}
    </>
  );
}
